
import React from 'react';
import { FacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate } from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowInventoryCalculationCutbackEditModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowInventoryCalculationCutbackEditModalStore(rootStore, componentProps), 'facilityOrderNewFlowInventoryCalculationCutbackEditModalStore')
@observer
class FacilityOrderNewFlowInventoryCalculationCutbackEditModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowInventoryCalculationCutbackEditModal;
